import React from "react";
import { Divider, useIsOverflowGroupVisible } from "@fluentui/react-components";
import { observer } from "mobx-react";

const OverflowSeparatorBase = (props: { groupId: string }) => {
    const { groupId } = props;
    const isGroupVisible = useIsOverflowGroupVisible(groupId) !== "hidden";

    return isGroupVisible ? <Divider appearance="strong" /> : null;
};

export const OverflowSeparator = observer(OverflowSeparatorBase);
